import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Calculate(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14l4-4h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7 9h2v2H7V9zm4 0h6v2h-6V9z" />
    </SvgIcon>
  )
}
